<!-- Sidebar -->
<aside
  class="h-full py-8 bg-cyan-950 text-white flex flex-col justify-between gap-20 items-start overflow-y-auto"
  [class]="isCollapsed() ? 'w-20 px-5' : 'w-72 px-7'">
  <div class="flex flex-col gap-20">
    <!-- Toggle Button -->
    @if (!isCollapsed()) {
    <div class="flex items-center gap-2">
      <div>
        <img alt="Logo" height="55" ngSrc="logo.png" priority width="575" />
      </div>
      <p-button
        [icon]="'pi pi-arrow-down-left-and-arrow-up-right-to-center'"
        [text]="true"
        (onClick)="toggleSidebar()" />
    </div>
    } @else {
    <div class="flex flex-col items-center gap-6">
      <p-button
        pTooltip="Expand Sidebar"
        [icon]="'pi pi-arrow-up-right-and-arrow-down-left-from-center'"
        [text]="true"
        (onClick)="toggleSidebar()" />
      <img alt="Logo" height="20" ngSrc="logo-short.png" priority width="10" />
    </div>
    }

    <!-- Navigation Menu -->
    <nav class="flex flex-col gap-8">
      <div>
        @if (!isCollapsed()) {
        <h3 class="text-base font-semibold text-white mb-6">Main Menu</h3>
        }
        <ul class="space-y-1">
          <li>
            <a
              app-sidebar-item
              icon="pi pi-folder"
              label="Cases"
              routerLink="case"
              [isCollapsed]="isCollapsed()"
              [pTooltip]="isCollapsed() ? 'Cases' : ''">
            </a>
          </li>
        </ul>
      </div>
      <hr class="border-t border-slate-600" />
      @if(isAdmin()) {
      <div>
        @if (!isCollapsed()) {
        <h3 class="text-base font-semibold text-white mb-6">Admin</h3>
        }
        <ul class="space-y-1">
          <li>
            <a
              app-sidebar-item
              icon="pi pi-users"
              label="Users"
              routerLink="user"
              [isCollapsed]="isCollapsed()"
              [pTooltip]="isCollapsed() ? 'Users' : ''">
            </a>
          </li>
        </ul>
      </div>

      <hr class="border-t border-slate-600" />
      }
      <div>
        @if (!isCollapsed()) {
        <h3 class="text-base font-semibold text-white mb-6">Font Size</h3>
        <div class="flex items-center gap-3">
          <p-button
            icon="pi pi-minus"
            pTooltip="Decrease font size"
            severity="secondary"
            size="small"
            [disabled]="!canDecrease()"
            [text]="true"
            (onClick)="decreaseFontSize()" />
          <span class="text-sm font-medium">{{ selectedFontSize() }}px</span>
          <p-button
            icon="pi pi-plus"
            pTooltip="Increase font size"
            severity="secondary"
            size="small"
            [disabled]="!canIncrease()"
            [text]="true"
            (onClick)="increaseFontSize()" />
        </div>
        } @else {
        <div class="flex flex-col gap-2 items-center">
          <p-button
            icon="pi pi-plus"
            pTooltip="Increase font size"
            severity="secondary"
            size="small"
            [disabled]="!canIncrease()"
            [text]="true"
            (onClick)="increaseFontSize()" />
          <span class="text-xs font-medium">{{ selectedFontSize() }}</span>
          <p-button
            icon="pi pi-minus"
            pTooltip="Decrease font size"
            severity="secondary"
            size="small"
            [disabled]="!canDecrease()"
            [text]="true"
            (onClick)="decreaseFontSize()" />
        </div>
        }
      </div>
    </nav>
    <!-- End of Navigation Menu -->
  </div>
  @if(!isCollapsed()) {
  <p-button label="Logout" severity="primary" variant="outlined" (onClick)="logout.emit()" />
  } @else {
  <p-button icon="pi pi-sign-out" pTooltip="Logout" severity="primary" (onClick)="logout.emit()" />
  }
</aside>
<!-- End of Sidebar -->
